<template>
  <div footer>
    <div class="mobile">
      <div class="contact">
        <a href="http://m.gynpadmall.com/product/가인패드h/51/category/1/display/2/" target="_blank">가인패드가 뭐죠?</a>
        <a href="http://m.gynpadmall.com/product/가인패드h/51/category/1/display/2/" target="_blank">가인패드 쇼핑몰 바로가기</a>
      </div>
      <div class="sns">
        <a class="fb" target="_blank" href="https://www.facebook.com/GynPad-789506964581927"></a>
        <a class="blog" target="_blank" href="https://blog.naver.com/tcmbio"></a>
        <a class="insta" target="_blank" href="https://www.instagram.com/gynpad/"></a>
      </div>
      <div class="company">
        13487 경기도 성남시 분당구 판교로228번길 15<br>
        (삼평동, 판교세븐벤처밸리1) 3동 3층<br>
        TEL : 1544-2719 | FAX : 031-698-3047
      </div>
      <img src="/static/img/common/footer_win_m.png" alt="" class="win">
      <div class="copyright">
        COPYRIGHTⓒ 2017 TCM Biosciences Inc. ALL RIGHTS RESERVED<br>
        이 제품은 채혈 또는 수혈 및 생체검사용 ‘의료기기’이며,<br>
        '사용상의 주의사항'과 '사용방법'을 잘 읽고 사용하십시오.<br>
        광고심의필 : 심의 번호 2018-I10-15-0991
      </div>
      <img class="logo" src="/static/img/common/logo_bottom_m.png">
    </div>
    <div class="pc">
      <div class="left">
        <img src="/static/img/common/footer_win_pc.png" alt="" class="win">
        <img src="/static/img/common/logo_bottom_tcm.png" alt="">
        <div class="txt">
          <p>13487 경기도 성남시 분당구 판교로228번길 15 (삼평동, 판교세븐벤처밸리1) 3동 3층   전화 : 1544-2719   팩스 : 031-698-3047<br>
            2018-|10-15-0991
            이 제품은 채혈 또는 수혈 및 생체검사용 '의료기기'이며, '사용상의 주의사항'과 '사용방법'을 잘 읽고 사용하십시오.  광고심의필 : 심의 번호 2018-I10-15-0991<br></p>
          <p>COPYRIGHTⓒ 2017 TCM Biosciences Inc. ALL RIGHTS RESERVED</p>
        </div>
      </div>
      <div class="right">
        <img src="/static/img/common/logo_bottom_lab.png">
        <div class="contact">
          <a href="tel:1544-2719" class="call">상담전화 1544-2719</a>
          <a href="http://gynpadmall.com" target="_blank" class="btn">가인패드 구매하기</a>
          <!--<a href="" class="btn">회사소개</a>-->
        </div>
      </div>
      <div class="go-top-bar" v-if="showGoTop">
        <div class="holder">
          <img src="/static/img/common/go-top.jpg" class="go-top hidden-md-down" @click="goTop">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getScrollBody } from '../util';

export default {
  name: 'Footer',
  methods: {
    goTop() {
      getScrollBody().animate({ scrollTop: 0 }, 300);
    },
    scroll() {
      this.showGoTop = (getScrollBody().scrollTop() > window.innerHeight);
    },
  },
  data() {
    return {
      showGoTop: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
    this.scroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
};
</script>

<style lang="less" scoped>
  @import "../less/gynpad";
  @import "../less/asset";

  .mobile { .tc; color: #999999; .rp-b(30); .lh(1.6);
    .contact { padding: 0 1rem;
      a {
        width: 100%;
        display: block;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        padding: 15px 0;
        margin: 10px 0;
        background: #212121;
        color: #fff;
        &:first-child {
          background: #f85c70;
          color: #fff;
        }
      }
    }
    .sns { .ib-list; padding-top: 1rem;
      a { .rwh(53); background-size: contain; .ir; .gap-h(2rem); background-repeat: no-repeat;
        &.fb { background-image: url(/static/img/common/c_fb.png); }
        &.blog { background-image: url(/static/img/common/c_blog.png); }
        &.insta { background-image: url(/static/img/common/c_insta.png); }
      }
    }
    .company { padding-top: 0.8rem; }
    .win { height: 6rem; }
    .copyright { padding-top: 0.8rem; .fs(0.9rem); }
    .logo { height: 2rem; margin-top: 0.8rem; }
  }
  .pc { display: none; }

  @media (min-width: @screen-lg-min) {
    .mobile { display: none; }
    .pc { .block; padding: 20px 30px; .lb; .wf; z-index: 10; background: rgba(255,255,255,0.6); .border-box;
      .left { .ib-list;
        .win { .h(64px) }
        .txt { margin-left: 27px; .fs(12px); color: #818081;
          p { margin-bottom: 5px; }
        }
      }
      .right { .rt(30px, 20px);
        & > * { .ib; .vab; .fs(13px); .igap-h(18px);
          .call { .block; .tr; .fs(15px); }
          .btn { padding:8px 12px; .border(@c-black); .lh(1); .igap-h(6px); margin-top: 7px; .block; }
        }
      }
      .go-top-bar { .rt(0, -69px); width: 100%; padding:0 20px;
        .holder { .tr; max-width: 1600px; .m-hc;
          img { cursor: pointer; }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue